export const ON_BIO_FIELD_CHANGE = '@ARI/Questionnaire/BioField/ON_BIO_FIELD_CHANGE';
export const ON_BIO_FIELD_BLUR = '@ARI/Questionnaire/BioField/ON_BIO_FIELD_BLUR';
export const SET_BIO_FIELD_VALIDATORS = '@ARI/Questionnaire/BioField/SET_BIO_FIELD_VALIDATORS';
export const SET_BIO_FIELD_VALUES = '@ARI/Questionnaire/BioField/SET_BIO_FIELD_VALUES';
export const SET_BIO_FIELD_SETTINGS = '@ARI/Questionnaire/BioField/SET_BIO_FIELD_SETTINGS';
export const SET_BIO_FIELD_ERRORS = '@ARI/Questionnaire/BioField/SET_BIO_FIELD_ERRORS';
export const ON_COUNTRY_FIELD_CHANGE = '@ARI/Questionnaire/BioField/ON_COUNTRY_FIELD_CHANGE';